<template>
  <div class="login">
    <div>
      <div class="login__title">Введите номер телефона</div>
      <div class="login__description">Чтобы войти или зарегистрироваться</div>
      <double-input
        class="login__input"
        mask="+7 (###) ###-##-##"
        picture="handset"
        title="Телефон"
        :has-error="hasPhoneError"
        :error-text="errorPhoneText"
        @input-changed="checkLength"
      />
    </div>
    <div>
      <new-button
        :loading="isLoading"
        title="Продолжить"
        type="primary"
        width="fullWidth"
        @button-clicked="sendRequest"
      />
    </div>
  </div>
</template>

<script>
import { CODE_LENGTH } from './const'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import DoubleInput from './DoubleInput'
import NewButton from '@/components/Drivers/NewButton/NewButton'

const isProd = process.env.NODE_ENV === 'production'
const Auth = RepositoryFactory.get('auth')

export default {
  name: 'AuthLogin',
  components: {
    NewButton,
    DoubleInput,
  },
  data() {
    return {
      phoneNumber: '',
      hasPhoneError: false,
      isLoading: false,
      timerInterval: 0,
      code: null,
    }
  },
  computed: {
    errorPhoneText() {
      return this.phoneNumber.length ? 'Некорректный номер' : 'Введите номер'
    },
    dataReady() {
      return this.phoneNumber.length === 18
    },
  },
  methods: {
    checkLength(phoneNumber) {
      this.phoneNumber = phoneNumber
      this.hasPhoneError = !this.dataReady
    },
    sendRequest() {
      this.checkLength(this.phoneNumber)
      if (this.dataReady) {
        this.isLoading = true
        Auth.getcode(this.phoneNumber)
          .then(res => {
            this.timerInterval = res.data.can_send_after || 120
            // для вывода на экран кода в режиме тестового сервера
            if (!isProd) {
              let code = res.data.message.slice(0, CODE_LENGTH)
              this.code = (code[0] === 'А') ? null : code
            }
            this.$emit(
              'login-sent',
              this.phoneNumber,
              res.data.already_registered,
              this.timerInterval,
              this.code,
            )
          })
          .catch(err => this.errHandler(err))
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.login__input
  margin-top: 3.2rem
</style>
